export interface TanstackRepositoryArgs<TCollection> {
  collection: TCollection;
}

export abstract class TanstackBaseRepository<TCollection> {
  protected readonly collection: TCollection;
  protected readonly repositoryName: string;

  protected constructor({ collection }: TanstackRepositoryArgs<TCollection>) {
    this.collection = collection;
    this.repositoryName = this.constructor.name;
  }
}
